import axios from 'axios';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/dnspublic/';

class DnsClenteService {
    constructor() {
    }

    get(dns) {
        console.log('Here');
        console.log(API_URL);
        return axios.get(API_URL+dns, {headers: this.headers});
    }

}

export default new DnsClenteService();